import useMediaQuery from '@mui/material/useMediaQuery'

const useReducedMotion = () => useMediaQuery('(prefers-reduced-motion: reduce)')

export default useReducedMotion
